import { useSelector } from 'react-redux';
import BootstrapTable from 'react-bootstrap-table-next';
import { AnalyticsSpinner } from '../../../components/common/Spinner/AnalyticsSpinner';
import { stringOrDashFormatter } from '../../../utils/formatHelper';
import { CUSTOM_INTEGRATION_DISPLAY_NAME, IntegrationDisplayNames } from '../../../constants/integrationTypes';

import styles from './OperatorSellerPage.module.scss';

export function OperatorWarehouses() {
  const {
    warehouses,
    loading: { warehouses: loading },
  } = useSelector((state) => state.operators);

  const columns = [
    {
      text: 'Name',
      dataField: 'name',
      sort: true,
    },
    {
      text: 'Address',
      dataField: 'address',
      formatter: stringOrDashFormatter,
    },
    {
      text: 'City',
      dataField: 'city',
      formatter: stringOrDashFormatter,
    },
    {
      text: 'Country',
      dataField: 'country',
      formatter: stringOrDashFormatter,
    },
    {
      text: 'State',
      dataField: 'state',
      formatter: stringOrDashFormatter,
    },
    {
      text: 'Zip code',
      dataField: 'zip_code',
      formatter: stringOrDashFormatter,
    },
    {
      text: 'Integrations',
      dataField: 'integrations',
      formatter: (cell, row) => {
        const { inventory_integration_type: inventory, orders_integration_type: orders } = row;
        const inventoryDisplayName = IntegrationDisplayNames[inventory] || CUSTOM_INTEGRATION_DISPLAY_NAME;
        const ordersDisplayName = IntegrationDisplayNames[orders] || CUSTOM_INTEGRATION_DISPLAY_NAME;

        if (inventoryDisplayName === ordersDisplayName) {
          return inventoryDisplayName;
        }

        return (
          <div className={styles.integrationsCell}>
            <div>
              <strong>Inventory</strong> - {inventoryDisplayName}
            </div>
            <div>
              <strong>Orders</strong> - {ordersDisplayName}
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <fieldset className={styles.sectionWrapper}>
      <h2>Seller's Warehouses</h2>

      {loading || !warehouses?.length ? (
        <div className={styles.emptyTable}>{loading ? <AnalyticsSpinner /> : <h3>No warehouses</h3>}</div>
      ) : (
        <div className={styles.tableWrapper}>
          <BootstrapTable data={warehouses} columns={columns} keyField="name" striped hover bordered={false} />
        </div>
      )}
    </fieldset>
  );
}
